<template>
  <section v-bind:id="menuItem.anchor" class="info p-90-0-60">
    <div class="container">
      <div class="row">

        <div class="col-12 mb-30 align-self-center">
          <h2 class="light dark mb-30">{{menuItem.name}} <span class="bold">{{menuItem.nameBold}}</span></h2>
        </div>
        <div class="col-12 col-lg-12 info-slider mb-30">
          <!-- Slider -->
          <div class="swiper-container swiper-1 swiper-container-horizontal">
            <div class="swiper-wrapper" style="transition-duration: 1100ms; transform: translate3d(-1270px, 0px, 0px);">

              <!-- Slides -->
              <div v-for="image in images" class="swiper-slide" style="width: 635px;">
                <div class="swiper-img" v-bind:style="'background-image: url(' + image + ')'"></div>
              </div>

            </div>
          </div>
          <!-- Slider end -->
        </div>

        <!-- Slider pagination -->
        <div class="col-12 d-flex justify-content-center">
          <div id="swiperPagination"></div>
        </div>

        <!-- end Slider pagination -->
      </div>
    </div>
  </section>
</template>

<script>
  require('swiper/dist/css/swiper.min.css')
  const Swiper = require('swiper/dist/js/swiper')

  export default {
    components: {
    },
    data () {
      return {
        images: [
          '/static/img/praxis/p01.jpg',
          '/static/img/praxis/p02.jpg',
          '/static/img/praxis/p03.jpg',
          '/static/img/praxis/p04.jpg',
          '/static/img/praxis/p05.jpg',
          '/static/img/praxis/p06.jpg',
          '/static/img/praxis/p07.jpg',
          '/static/img/praxis/p08.jpg'
        ],
        swiper: null
      }
    },
    props: ['menuItem'],
    computed: {},
    mounted: function () {
      this.swiper = new Swiper('.swiper-1', {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,

        autoplay: {
          delay: 6000
        },
        loop: true,
        speed: 1100,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        },
        slidesPerView: 'auto',
        pagination: {
          el: '#swiperPagination',
          type: 'bullets',
          clickable: true
        }
      })
    },
    methods: {}
  }
</script>

<style>
  .swiper-pagination-bullet {
    width: 20px!important;
    height: 20px!important;
    background-color: #aaaaaa!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/sections/Gallery.vue